/** Role helpers for admin portal access control */

export const ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  MEMBER: 'member'
};

export const normalizeStaffUser = (user) => {
  if (!user) return null;
  // Seed account is always super admin
  if (user.username === 'admin') {
    return { ...user, role: ROLES.SUPER_ADMIN };
  }
  const role = user.role === 'user' ? ROLES.ADMIN : (user.role || ROLES.ADMIN);
  return { ...user, role };
};

export const isSuperAdmin = (user) => normalizeStaffUser(user)?.role === ROLES.SUPER_ADMIN;

export const canAccessSetup = (user) => isSuperAdmin(user);

/** Fee / timeline auto-calculator + quote generator */
export const canUseFeeTimelineCalculator = (user) => isSuperAdmin(user);

export const getStoredStaffUser = () => {
  try {
    return normalizeStaffUser(JSON.parse(localStorage.getItem('user') || 'null'));
  } catch {
    return null;
  }
};
